'use client';

import { chatMessagesType } from '@/type/chat';
import { createContext, ReactNode, useContext, useEffect, useRef, useState } from 'react';
import { AuthContext } from './authContext';
import { MessageContext } from './messageContext';
interface updateTypes {}
export const UpdateContext = createContext<updateTypes>({})

export default function UpdateSocketClient({ children }: { children: ReactNode }) {
    const {loading, user, userUpdate, getUserDetail} = useContext(AuthContext)
    const { messageShow, fetchData }  = useContext(MessageContext)
    const socketRef = useRef<WebSocket | null>(null);


    useEffect(() => {
        if(loading || !user.is_authenticated) return;

        // 로그인 되었을 때만 연결
        const host = process.env.NODE_ENV === 'development' ? "127.0.0.1:8000" : window.location.host
        // const host = process.env.NODE_ENV === 'development' ? "spottv.ap-northeast-2.elasticbeanstalk.com" : window.location.host
        const protocol = window.location.protocol === "https:" ? 'wss' : 'ws'
        const socketURL = `${protocol}://${host}/ws/user_info/`

        const socket = new WebSocket(socketURL);
        socketRef.current = socket;

        socket.onopen = () => {
            // console.log('Chat WebSocket connected');

            


        };

        socket.onmessage = (e) => {
            const data = JSON.parse(e.data)
            if(data.action == 'info_update'){
                userUpdate({ point: data.point, exp: data.exp })
            }else if(data.action == 'message_update'){
                // console.log(data)
                if(data.is_message || data.is_verified_message || data.is_global){
                    // console.log(1)
                    fetchData('user', 1)
                    getUserDetail()
                }
            }
        };

        socket.onclose = () => {
            // console.log('Chat WebSocket disconnected');
        };

        return () => {
            socket.close();
        };
    }, [loading, user]);

    const contextValue = {}

    return (
        <UpdateContext.Provider value={contextValue}>{children}</UpdateContext.Provider>
    );
};
